<template>
  <!-- 泳池长度 -->
  <FormItem
    v-if="[3].includes(sportType)"
    :label="$t('S4682')"
  >
    <InputGroup class="w-full flex">
      <Select
        v-model="poolLengthType"
        class="basic-item fast-intensity-type border-dark-60 relative !z-30 flex-1"
        :class="{ 'w-[150px]': poolLengthType === 0 }"
        :options="poolLengthOptions"
        :disabled="readonly"
        :trigger-props="{ updateAtScroll: true }"
      >
      </Select>
      <template v-if="poolLengthType === 0">
        <!-- 自定义泳池长度 -->
        <InputNumber
          v-model:model-value="customPoolLength"
          :disabled="readonly"
          class="w-[100px]"
          :max="corosSportConfig.sport.poolSwim.customPoolLengthMax"
          :min="corosSportConfig.sport.poolSwim.customPoolLengthMin"
        />
        <Select
          class="w-80"
          :disabled="readonly"
          v-model="poolLengthUnit"
          :options="poolLengthUnitOptions"
        />
      </template>
    </InputGroup>
  </FormItem>
</template>

<script lang="ts" setup>
import { FormItem, Select, InputGroup, InputNumber } from '@arco-design/web-vue';
import { useSwimPoolLength } from '../../hooks/useSwimPoolLength';

import * as corosSportConfig from '@coros/sport-config';

defineProps<{
  sportType: number;
  readonly: boolean;
}>();

const { poolLengthType, customPoolLength, poolLengthUnit, poolLengthOptions, poolLengthUnitOptions } = useSwimPoolLength();
</script>
